<template>
  <div class="loading">
    <p>Please wait... loading content!</p>
  </div>
</template>

<script>
export default {}
</script>
